// extracted by mini-css-extract-plugin
module.exports = {"description":"_3WEsAhb"};